module.exports = __webpack_public_path__ + "img/amex.22461754.jpg";